// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__lmWV2","upload":"Small_upload__2N9KA","imageWrap":"Small_imageWrap__3i1BK","removeBtn":"Small_removeBtn__1KHV2"};